import React, { useState } from 'react';
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Clear as ClearIcon, Search as SearchIcon } from '@mui/icons-material';
import UbicacionSearch from '../UbicacionSearch';
import { IUbicacion } from '../../interfaces/Ubicacion';
import type { UbicacionUsuarioDraft } from '../../utils/syncUbicacionesUsuario';

interface UbicacionPredeterminadaAdminSectionProps {
  value: UbicacionUsuarioDraft | null;
  onChange: (value: UbicacionUsuarioDraft | null) => void;
  disabled?: boolean;
}

const UbicacionPredeterminadaAdminSection: React.FC<UbicacionPredeterminadaAdminSectionProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const [searchOpen, setSearchOpen] = useState(false);

  const handleSelect = (ubicacion: IUbicacion) => {
    onChange({
      nroUbicacion: ubicacion.nroUbicacion,
      nombreUbicacion: ubicacion.nombreUbicacion?.trim() || `Ubicación ${ubicacion.nroUbicacion}`,
      preferida: true,
    });
    setSearchOpen(false);
  };

  const label = value
    ? `${value.nombreUbicacion} (${value.nroUbicacion})`
    : '';

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Los usuarios con rol Admin tienen acceso a todas las ubicaciones. Opcionalmente puede definir
        una ubicación por defecto para autocompletar formularios de compra y venta.
      </Typography>

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} alignItems={{ sm: 'center' }}>
        <TextField
          fullWidth
          label="Ubicación por defecto"
          value={label}
          placeholder="Sin ubicación por defecto"
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                {value && (
                  <IconButton
                    onClick={() => onChange(null)}
                    disabled={disabled}
                    edge="end"
                    size="small"
                    aria-label="Quitar ubicación por defecto"
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                )}
                <IconButton
                  onClick={() => setSearchOpen(true)}
                  disabled={disabled}
                  edge="end"
                  size="small"
                  aria-label="Buscar ubicación"
                >
                  <SearchIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
          onClick={() => !disabled && setSearchOpen(true)}
          disabled={disabled}
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
        />
        <Button
          variant="outlined"
          onClick={() => setSearchOpen(true)}
          disabled={disabled}
          sx={{ textTransform: 'none', borderRadius: 2, whiteSpace: 'nowrap', flexShrink: 0 }}
        >
          Elegir ubicación
        </Button>
      </Stack>

      <UbicacionSearch
        open={searchOpen}
        onClose={() => setSearchOpen(false)}
        onSelect={handleSelect}
        loadAllUbicaciones
      />
    </Box>
  );
};

export default UbicacionPredeterminadaAdminSection;
